import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const AnalysisFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  documentOptions,
  onBulkAction 
}) => {
  const issueTypeOptions = [
    { value: 'all', label: 'All Issue Types' },
    { value: 'gap_detection', label: 'Gap Detection' },
    { value: 'inconsistencies', label: 'Inconsistencies' },
    { value: 'contradictions', label: 'Contradictions' },
    { value: 'grammar_issues', label: 'Grammar Issues' },
    { value: 'spelling_errors', label: 'Spelling Errors' },
    { value: 'language_issues', label: 'Language Issues' }
  ];

  const severityOptions = [
    { value: 'all', label: 'All Severities' },
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'pending', label: 'Pending' },
    { value: 'in_review', label: 'In Review' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'dismissed', label: 'Dismissed' }
  ];

  const sortOptions = [
    { value: 'severity_desc', label: 'Severity (High to Low)' },
    { value: 'severity_asc', label: 'Severity (Low to High)' },
    { value: 'date_desc', label: 'Date (Newest First)' },
    { value: 'date_asc', label: 'Date (Oldest First)' },
    { value: 'document', label: 'Document Name' },
    { value: 'type', label: 'Issue Type' }
  ];

  const bulkActionOptions = [
    { value: 'accept_all', label: 'Accept All Suggestions' },
    { value: 'create_change_requests', label: 'Create Change Requests' },
    { value: 'mark_reviewed', label: 'Mark as Reviewed' },
    { value: 'export_report', label: 'Export Analysis Report' }
  ];

  const hasActiveFilters = filters?.document !== 'all' || 
                          filters?.issueType !== 'all' || 
                          filters?.severity !== 'all' || 
                          filters?.status !== 'all' || 
                          filters?.searchQuery?.trim() !== '';

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-medium text-foreground">Filter & Actions</h2>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={14}
          >
            Clear Filters
          </Button>
        )}
      </div>
      {/* Search and Filters Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 mb-4">
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search findings, documents, or content..."
            value={filters?.searchQuery}
            onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
            className="w-full"
          />
        </div>

        <Select
          placeholder="Select document"
          options={documentOptions}
          value={filters?.document}
          onChange={(value) => onFilterChange('document', value)}
        />

        <Select
          placeholder="Issue type"
          options={issueTypeOptions}
          value={filters?.issueType}
          onChange={(value) => onFilterChange('issueType', value)}
        />

        <Select
          placeholder="Severity"
          options={severityOptions}
          value={filters?.severity}
          onChange={(value) => onFilterChange('severity', value)}
        />

        <Select
          placeholder="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />
      </div>
      {/* Sort and Bulk Actions Row */}
      <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Icon name="ArrowUpDown" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">Sort by:</span>
          </div>
          <Select
            options={sortOptions}
            value={filters?.sortBy}
            onChange={(value) => onFilterChange('sortBy', value)}
            className="w-48"
          />
        </div>

        <div className="flex items-center gap-3">
          <Select
            placeholder="Bulk actions"
            options={bulkActionOptions}
            value=""
            onChange={onBulkAction}
            className="w-48"
          />
          
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            iconSize={16}
            onClick={() => onBulkAction('export_report')}
          >
            Export Report
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AnalysisFilters;